<template>
  <div class="odt-root">
    <!-- <div class="odt-controls-bar">
      <div class="odt-controls-left"></div>

      <div class="odt-controls-right">
        <v-btn
          small
          color="#2e8aed"
          dark
          elevation="0"
          class="odt-btn-refresh"
          :loading="loading"
          :disabled="!canSearch"
          @click="consultarSecuencia"
        >
          <v-icon left size="15">mdi-refresh</v-icon>
          Refrescar
        </v-btn>
      </div>
    </div> -->

    <div class="odt-filter-panel">
      <v-row dense class="odt-filter-row">
        <v-col cols="12" md="3" class="odt-filter-col">
          <MxDateTimePicker
            class="odt-field odt-field--date"
            v-model="filtros.fechaInicio"
            label="Fecha inicio *"
            :dense="true"
            :clearable="true"
            output-format="YYYY-MM-DD HH:mm"
          />
        </v-col>
        <v-col cols="12" md="3" class="odt-filter-col">
          <MxDateTimePicker
            class="odt-field odt-field--date"
            v-model="filtros.fechaFin"
            label="Fecha fin *"
            :dense="true"
            :clearable="true"
            output-format="YYYY-MM-DD HH:mm"
          />
        </v-col>
        <v-col cols="12" md="3" class="odt-filter-col">
          <v-autocomplete
            class="odt-field"
            v-model="filtros.idTrabajoOrden"
            :items="trabajoOrdenes"
            item-value="idTrabajoOrden"
            :item-text="trabajoOrdenLabel"
            :loading="loadingCatalogos"
            label="ODT *"
            clearable
            hide-details="auto"
            dense
            @change="scheduleFetchMaquinas"
          />
        </v-col>
        <v-col cols="12" md="3" class="odt-filter-col">
          <v-autocomplete
            class="odt-field"
            v-model="filtros.idMaquinaIns"
            :items="maquinasDisponibles"
            item-value="idMaquinaIns"
            :item-text="maquinaLabel"
            :loading="loadingCatalogos || loadingMaquinas"
            label="Maquina *"
            no-data-text="No hay datos disponibles"
            :menu-props="{ maxHeight: 220 }"
            clearable
            hide-details="auto"
            dense
          />
        </v-col>
      </v-row>

      <v-row dense class="odt-filter-row">
        <v-col cols="3" md="3" class="odt-filter-col">
          <v-autocomplete
            class="odt-field"
            v-model="filtros.idParoTipo"
            :items="paroTipos"
            item-value="idParoTipo"
            item-text="nombre"
            :loading="loadingCatalogos"
            label="Tipo de paro"
            clearable
            hide-details="auto"
            dense
            @change="filtros.idSubParoTipo = null"
          />
        </v-col>
        <v-col cols="3" md="3" class="odt-filter-col">
          <v-autocomplete
            class="odt-field"
            v-model="filtros.idSubParoTipo"
            :items="subParosFiltrados"
            item-value="idSubParoTipo"
            item-text="nombreSubParoTipo"
            :loading="loadingCatalogos"
            label="Subtipo de paro"
            clearable
            hide-details="auto"
            dense
          />
        </v-col>
      </v-row>

      <div class="odt-actions">
        <v-btn color="primary" :loading="loading" :disabled="!canSearch" @click="consultarSecuencia">Consultar</v-btn>
        <v-btn text :disabled="loading" @click="limpiar">Limpiar</v-btn>
      </div>
    </div>

    <div class="odt-kpi-grid">
      <article
        v-for="card in kpiCards"
        :key="card.key"
        class="odt-kpi-card"
        :class="[`odt-kpi-card--${card.tone}`]"
      >
        <div class="odt-kpi-top">
          <div class="odt-kpi-top-main">
            <div class="odt-kpi-icon-pack" :class="`odt-kpi-icon-pack--${card.tone}`">
              <v-icon class="odt-kpi-icon-main">{{ card.icon }}</v-icon>
            </div>
            <p class="odt-kpi-title">{{ card.title }}</p>
          </div>
        </div>
        <div class="odt-kpi-value-row">
          <p class="odt-kpi-value-main" :class="`odt-kpi-value-main--${card.tone}`">{{ card.value }}</p>
        </div>
        <p class="odt-kpi-caption">{{ card.caption }}</p>
      </article>
    </div>

    <v-alert v-if="error" class="mt-4" type="error" dense outlined>{{ error }}</v-alert>

    <div class="odt-section-label">
      <i class="odt-dot"></i>
      RESULTADO SECUENCIA
      <span class="odt-count-badge">{{ groupedRowsOrdenadas.length }} registros</span>
    </div>

    <div class="odt-panel">
      <div v-if="loading" class="odt-loader">
        <v-progress-circular indeterminate color="#2e8aed" size="36" width="3" />
        <span class="odt-loader-text">Cargando reporte...</span>
      </div>
      <div class="odt-table-wrap">
        <table class="odt-table">
          <thead>
            <tr>
              <th
                v-for="h in parentHeaders"
                :key="h.value"
                class="odt-th odt-th--sortable"
                @click="sortBy(h.value)"
              >
                {{ h.text }} {{ sortIcon(h.value) }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="groupedRowsOrdenadas.length === 0">
              <td :colspan="Math.max(parentHeaders.length, 1)" class="odt-empty">Sin registros para mostrar.</td>
            </tr>
            <template v-for="(row, idx) in groupedRowsOrdenadas">
              <tr :key="`row-${row.groupKey || idx}`" class="odt-tr odt-tr--clickable" @click="toggleGroup(row.groupKey)">
                <td class="odt-td">{{ row.ODT }}</td>
                <td class="odt-td">{{ row.Maquina }}</td>
                <td class="odt-td">{{ row.TotalParos }}</td>
                <td class="odt-td">{{ row.DuracionHoras }}</td>
                <td class="odt-td odt-td--center">
                  <v-icon small color="#2e8aed">{{ isExpanded(row.groupKey) ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
                </td>
              </tr>

              <tr v-if="isExpanded(row.groupKey)" :key="`row-detail-${row.groupKey || idx}`" class="odt-tr-detail">
                <td :colspan="parentHeaders.length" class="odt-td-detail">
                  <div class="odt-subtable-wrap">
                    <table class="odt-subtable">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Causa</th>
                          <th>Subcausa</th>
                          <th>Artículo</th>
                          <th>Hora inicio paro</th>
                          <th>Hora fin paro</th>
                          <th>Duración del paro</th>
                          <th>Tiempo desde inicio/cierre</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="!row.paros.length">
                          <td colspan="8" class="odt-empty">Sin detalle de paros.</td>
                        </tr>
                        <tr v-for="(p, pIdx) in row.paros" :key="`${row.groupKey}-${pIdx}`">
                          <td>{{ pIdx + 1 }}</td>
                          <td>{{ p.causa || "—" }}</td>
                          <td>{{ p.subCausa || "—" }}</td>
                          <td>{{ p.articulo || "—" }}</td>
                          <td>{{ p.inicio || "—" }}</td>
                          <td>{{ p.fin || "—" }}</td>
                          <td>{{ p.duracion || "—" }}</td>
                          <td>{{ p.tiempoDesde || "—" }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import MxDateTimePicker from "@/components/MxDateTimePicker.vue";

export default {
  name: "ReportesdeReinicios",
  components: { MxDateTimePicker },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      loadingCatalogos: false,
      error: null,
      rawResponse: null,
      trabajoOrdenes: [],
      maquinas: [],
      maquinasOdt: [],
      paroTipos: [],
      subParoTipos: [],
      loadingMaquinas: false,
      errorMaquinas: null,
      _tmFetchMaquinas: null,
      _tmFetchTrabajoOrdenes: null,
      sortKey: "",
      sortDesc: false,
      expandedGroups: {},
      filtros: {
        idTrabajoOrden: null,
        idMaquinaIns: null,
        fechaInicio: "",
        fechaFin: "",
        idParoTipo: null,
        idSubParoTipo: null,
      },
    };
  },
  computed: {
    canSearch() {
      return (
        Number(this.filtros.idTrabajoOrden) > 0 &&
        Number(this.filtros.idMaquinaIns) > 0 &&
        !!this.filtros.fechaInicio &&
        !!this.filtros.fechaFin
      );
    },
    subParosFiltrados() {
      if (!this.filtros.idParoTipo) return this.subParoTipos;
      return this.subParoTipos.filter(
        (x) => Number(x?.idParoTipo) === Number(this.filtros.idParoTipo)
      );
    },
    maquinasDisponibles() {
      const source = this.maquinasOdt.length ? this.maquinasOdt : this.maquinas;
      return (source || []).filter((x) => !!(x && x.maquina));
    },
    rowsDisplay() {
      if (!Array.isArray(this.rawResponse)) return [];
      return this.rawResponse.map((row) => {
        const out = {};
        const idTrabajoOrden = this.pickNumber(row, ["idTrabajoOrden", "IdTrabajoOrden"]);
        const idMaquinaIns = this.pickNumber(row, ["idMaquinaIns", "IdMaquinaIns"]);
        const idParoTipo = this.pickNumber(row, ["idParoTipo", "IdParoTipo"]);
        const idSubParoTipo = this.pickNumber(row, ["idSubParoTipo", "IdSubParoTipo"]);
        out._horaInicioOdt = row?.otInicio ?? row?.OtInicio ?? row?.otinicio ?? "";

        if (idTrabajoOrden > 0) {
          const ot = this.trabajoOrdenes.find((x) => Number(x?.idTrabajoOrden) === idTrabajoOrden);
          out.ODT = ot?.clave || `ODT ${idTrabajoOrden}`;
        }
        const maquinaDirecta =
          row?.maquina ??
          row?.Maquina ??
          row?.nombreMaquina ??
          row?.NombreMaquina ??
          "";
        if (maquinaDirecta) {
          out.Maquina = maquinaDirecta;
        } else if (idMaquinaIns > 0) {
          const maq = this.maquinas.find((x) => Number(x?.idMaquinaIns) === idMaquinaIns);
          const labelMaq = maq ? this.maquinaLabel(maq) : "";
          out.Maquina = labelMaq || `M${idMaquinaIns}`;
        }
        out.CodigoMolde =
          row?.codigoMolde ??
          row?.CodigoMolde ??
          row?.codigomolde ??
          row?.molde ??
          row?.Molde ??
          "";
        if (idParoTipo > 0) {
          const tipo = this.paroTipos.find((x) => Number(x?.idParoTipo) === idParoTipo);
          out.TipoParo = tipo?.nombre || `${idParoTipo}`;
        }
        if (idSubParoTipo > 0) {
          const sub = this.subParoTipos.find((x) => Number(x?.idSubParoTipo) === idSubParoTipo);
          out.SubtipoParo = sub?.nombreSubParoTipo || `${idSubParoTipo}`;
        }
        Object.keys(row || {}).forEach((k) => {
          const kLower = String(k || "").toLowerCase().trim();
          if (this.isIdField(k)) return;
          if (kLower.includes("operador") || kLower === "otclave" || kLower === "paronum" || kLower === "tipoparo" || kLower === "otinicio") return;
          if (kLower === "maquina" || kLower === "nombremaquina") return;
          if (kLower === "duracionsegundos") {
            out[k] = this.formatDurationHM(row[k]);
            return;
          }
          out[k] = row[k];
        });
        out._isParo = this.rowIsParo(out);
        out._isVencida = this.rowIsVencida(out);
        out._isProxima = this.rowIsProxima(out);
        return out;
      });
    },
    groupedRows() {
      const groups = {};
      this.rowsDisplay.forEach((row) => {
        const key = `${row?.ODT || "—"}|${row?.Maquina || "—"}`;
        if (!groups[key]) {
          groups[key] = {
            groupKey: key,
            ODT: row?.ODT || "—",
            Maquina: row?.Maquina || "—",
            CodigoMolde: row?.CodigoMolde || "—",
            TotalParos: 0,
            DuracionHoras: "0h 0m",
            _durSecTotal: 0,
            HoraInicioODT: row?._horaInicioOdt || "",
            paros: [],
          };
        }

        const causa = this.getByPatterns(row, ["causa"]);
        const subCausa = this.getByPatterns(row, ["subcausa", "sub causa"]);
        const articulo = row?.codigoArticulo ?? row?.CodigoArticulo ?? "";
        const inicio = row?.inicio ?? row?.Inicio ?? "";
        const fin = this.getByPatterns(row, ["fin"]);
        const tiempoDesdeRaw = this.getByPatterns(row, ["tiempo desde", "tiempodesde", "transcurrido"]);
        const duracionRaw = this.getByPatterns(row, ["duracionsegundos", "duraciónsegundos", "duracion"]);
        const durSec = this.parseDurationToSeconds(duracionRaw);
        const duracion = durSec > 0 ? this.formatDurationHM(durSec) : (duracionRaw || "—");
        const tiempoDesdeSec = this.parseDurationToSeconds(tiempoDesdeRaw);
        const tiempoDesde = tiempoDesdeRaw === "" || tiempoDesdeRaw == null
          ? ""
          : this.formatDurationHM(tiempoDesdeSec);
        const inicioOdt = row?._horaInicioOdt || groups[key].HoraInicioODT || "";
        if (!groups[key].HoraInicioODT && inicioOdt) groups[key].HoraInicioODT = inicioOdt;
        if ((!groups[key].CodigoMolde || groups[key].CodigoMolde === "—") && row?.CodigoMolde) {
          groups[key].CodigoMolde = row.CodigoMolde;
        }

        groups[key].paros.push({ causa, subCausa, articulo, inicioOdt, inicio, fin, duracion, tiempoDesde });
        groups[key].TotalParos += 1;
        groups[key]._durSecTotal += Math.max(0, durSec);
        groups[key].DuracionHoras = this.formatDurationHM(groups[key]._durSecTotal);
      });
      return Object.values(groups);
    },
    groupedRowsOrdenadas() {
      const rows = [...this.groupedRows];
      if (!this.sortKey) return rows;
      const d = this.sortDesc ? -1 : 1;
      rows.sort((a, b) => {
        const va = a?.[this.sortKey];
        const vb = b?.[this.sortKey];
        const na = Number(va);
        const nb = Number(vb);
        if (Number.isFinite(na) && Number.isFinite(nb)) return (na - nb) * d;
        return String(va ?? "").localeCompare(String(vb ?? "")) * d;
      });
      return rows;
    },
    parentHeaders() {
      return [
        { text: "ODT", value: "ODT" },
        { text: "Maquina", value: "Maquina" },
        { text: "Total Paros", value: "TotalParos" },
        { text: "Duración Horas", value: "DuracionHoras" },
        { text: "Detalle", value: "_detail" },
      ];
    },
    kpiCards() {
      const total = this.rowsDisplay.length;
      const horaInicioOdt =
        this.groupedRows.find((r) => String(r?.HoraInicioODT || "").trim())?.HoraInicioODT || "—";
      const totalTiempoParos = this.rowsDisplay.reduce((acc, row) => {
        const duracionRaw = this.getByPatterns(row, ["duracionsegundos", "duraciónsegundos", "duracion"]);
        return acc + this.parseDurationToSeconds(duracionRaw);
      }, 0);
      const moldes = [...new Set(this.rowsDisplay.map((r) => r.CodigoMolde).filter(Boolean))];
      const moldeTrabajado = moldes[0] || "—";
      const causaCounts = {};
      this.groupedRows.forEach((g) => {
        (g.paros || []).forEach((p) => {
          const causa = String(p?.causa || "").trim();
          if (!causa) return;
          causaCounts[causa] = (causaCounts[causa] || 0) + 1;
        });
      });
      const causaMasRepetida = Object.entries(causaCounts)
        .sort((a, b) => b[1] - a[1])[0]?.[0] || "—";
      const causaMasRepetidaCount = Object.entries(causaCounts)
        .sort((a, b) => b[1] - a[1])[0]?.[1] || 0;
      return [
        {
          key: "hora-inicio-odt",
          title: "Hora inicio odt",
          value: horaInicioOdt,
          //caption: total > 1 ? `${total} registros en resultado` : "",
          icon: "mdi-cog-outline",
          tone: "blue",
        },
        {
          key: "total-tiempo-paros",
          title: "Total Tiempo Paros",
          value: this.formatDurationHM(totalTiempoParos),
          //caption: "Suma total del tiempo de paro mostrado",
          icon: "mdi-timer-outline",
          tone: "violet",
        },
        {
          key: "molde-trabajado",
          title: "Molde Trabajado",
          value: moldeTrabajado,
          caption: moldes.length > 1 ? `${moldes.length} moldes en resultados` : "",
          icon: "mdi-alert-outline",
          tone: "amber",
        },
        {
          key: "causa-repetida",
          title: "Causa más repetida",
          value: causaMasRepetida,
          caption: causaMasRepetidaCount > 0 ? `${causaMasRepetidaCount} repeticiones` : "",
          icon: "mdi-pause-circle-outline",
          tone: "slate",
        },
      ];
    },
  },
  watch: {
    "filtros.idTrabajoOrden": function () {
      this.filtros.idMaquinaIns = null;
      this.maquinasOdt = [];
      this.scheduleFetchMaquinas();
    },
    "filtros.fechaInicio": function () {
      this.scheduleFetchTrabajoOrdenes();
      this.scheduleFetchMaquinas();
    },
    "filtros.fechaFin": function () {
      this.scheduleFetchTrabajoOrdenes();
      this.scheduleFetchMaquinas();
    },
  },
  mounted() {
    this.cargarCatalogos();
  },
  beforeDestroy() {
    clearTimeout(this._tmFetchMaquinas);
    clearTimeout(this._tmFetchTrabajoOrdenes);
  },
  methods: {
    sortBy(key) {
      if (key === "_detail") return;
      if (this.sortKey === key) this.sortDesc = !this.sortDesc;
      else {
        this.sortKey = key;
        this.sortDesc = false;
      }
    },
    sortIcon(key) {
      if (key === "_detail") return "";
      if (this.sortKey !== key) return "⇅";
      return this.sortDesc ? "↓" : "↑";
    },
    toggleGroup(key) {
      this.$set(this.expandedGroups, key, !this.expandedGroups[key]);
    },
    isExpanded(key) {
      return !!this.expandedGroups[key];
    },
    capitalizeHeader(key) {
      const txt = String(key || "").trim();
      if (!txt) return "";
      const norm = txt.toLowerCase().replace(/\s+/g, "");
      if (norm === "duracionsegndos" || norm === "duracionsegundos") return "Duración Horas";
      return txt.charAt(0).toUpperCase() + txt.slice(1);
    },
    getByPatterns(obj, patterns = []) {
      const keys = Object.keys(obj || {});
      for (const pattern of patterns) {
        const p = String(pattern || "").toLowerCase().replace(/\s+/g, "");
        const key = keys.find((k) =>
          String(k || "").toLowerCase().replace(/\s+/g, "").includes(p)
        );
        if (key && obj[key] != null && `${obj[key]}`.trim() !== "") return obj[key];
      }
      return "";
    },
    parseDurationToSeconds(v) {
      if (v == null) return 0;
      if (typeof v === "number") return Math.max(0, Math.round(v));
      const txt = String(v).toLowerCase().trim();
      const n = Number(txt);
      if (Number.isFinite(n)) return Math.max(0, Math.round(n));
      const mh = txt.match(/(\d+)\s*h/);
      const mm = txt.match(/(\d+)\s*m/);
      const h = mh ? Number(mh[1]) : 0;
      const m = mm ? Number(mm[1]) : 0;
      if (h || m) return h * 3600 + m * 60;
      return 0;
    },
    formatDurationHM(totalSeconds) {
      const secs = Math.max(0, Math.round(Number(totalSeconds) || 0));
      const h = Math.floor(secs / 3600);
      const m = Math.floor((secs % 3600) / 60);
      return `${h}h ${m}m`;
    },
    formatDurationHHMM(totalSeconds) {
      const secs = Math.max(0, Math.round(Number(totalSeconds) || 0));
      const h = Math.floor(secs / 3600);
      const m = Math.floor((secs % 3600) / 60);
      return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
    },
    isIdField(key) {
      const k = String(key || "").toLowerCase().trim();
      return k === "id" || k.startsWith("id") || k.endsWith("id");
    },
    pickNumber(obj, keys) {
      for (const key of keys) {
        const n = Number(obj?.[key]);
        if (Number.isFinite(n) && n > 0) return n;
      }
      return 0;
    },
    trabajoOrdenLabel(item) {
      if (!item) return "";
      return item.clave || item.nombre || `ODT ${item.idTrabajoOrden}`;
    },
    maquinaLabel(maquina) {
      if (!maquina) return "";
      return maquina.maquina || "";
    },
    normalizeDateTime(value) {
      if (!value) return "";
      const raw = String(value).trim().replace("T", " ");
      const m = raw.match(/^(\d{2})-(\d{2})-(\d{4})\s+(\d{2}):(\d{2})$/);
      if (m) {
        const [, dd, mm, yyyy, hh, mi] = m;
        return `${yyyy}-${mm}-${dd} ${hh}:${mi}`;
      }
      return raw.length >= 16 ? raw.slice(0, 16) : raw;
    },
    scheduleFetchMaquinas() {
      clearTimeout(this._tmFetchMaquinas);
      this._tmFetchMaquinas = setTimeout(() => this.fetchMaquinasPorODT(), 250);
    },
    scheduleFetchTrabajoOrdenes() {
      clearTimeout(this._tmFetchTrabajoOrdenes);
      this._tmFetchTrabajoOrdenes = setTimeout(() => this.cargarCatalogos(), 250);
    },
    async fetchMaquinasPorODT() {
      const idOdt = Number(this.filtros.idTrabajoOrden);
      // console.log("[MaquinasPorOtT] trigger", {
      //   idTrabajoOrden: this.filtros.idTrabajoOrden,
      //   fechaInicio: this.filtros.fechaInicio,
      //   fechaFin: this.filtros.fechaFin,
      // });

      if (!idOdt || !this.filtros.fechaInicio || !this.filtros.fechaFin) {
        this.maquinasOdt = [];
        this.filtros.idMaquinaIns = null;
        this.errorMaquinas = null;
        return;
      }

      const fechaInicio = this.normalizeDateTime(this.filtros.fechaInicio);
      const fechaFin = this.normalizeDateTime(this.filtros.fechaFin);
      if (fechaFin <= fechaInicio) {
        this.errorMaquinas = "El rango de fechas no es valido.";
        this.maquinasOdt = [];
        this.filtros.idMaquinaIns = null;
        return;
      }

      const odt = this.trabajoOrdenes.find((x) => Number(x?.idTrabajoOrden) === idOdt);
      const idTrabajoOrdenDetalle = Number(odt?.idTrabajoOrdenDetalle ?? odt?.IdTrabajoOrdenDetalle ?? 0);
      const params = { fechaInicio, fechaFin };
      if (idTrabajoOrdenDetalle > 0) params.idTrabajoOrdenDetalle = idTrabajoOrdenDetalle;
      else params.idTrabajoOrden = idOdt;

      this.loadingMaquinas = true;
      this.errorMaquinas = null;
      try {
        const { data } = await axios.get("/Paros/MaquinasPorOT", { params });
        //console.log("[MaquinasPorOtT] params:", params, "response:", data);
        const itemsRaw = Array.isArray(data) ? data : [];
        const items = itemsRaw.map((x) => ({
          ...x,
          idMaquinaIns: Number(x?.idMaquinaIns ?? x?.IdMaquinaIns ?? 0),
        })).filter((x) => x.idMaquinaIns > 0);

        this.maquinasOdt = items;

        const actual = Number(this.filtros.idMaquinaIns);
        if (actual && !items.some((x) => Number(x.idMaquinaIns) === actual)) {
          this.filtros.idMaquinaIns = null;
        }
      } catch (err) {
        this.maquinasOdt = [];
        this.filtros.idMaquinaIns = null;
        this.errorMaquinas =
          err?.response?.data?.mensaje ||
          err?.response?.data?.message ||
          err?.message ||
          "No se pudieron cargar las maquinas para la ODT.";
      } finally {
        this.loadingMaquinas = false;
      }
    },
    toDateMaybe(v) {
      if (!v) return null;
      const d = new Date(v);
      return Number.isFinite(d.getTime()) ? d : null;
    },
    rowIsParo(row) {
      const v1 = String(row?.TipoParo || "").trim();
      const v2 = String(row?.SubtipoParo || "").trim();
      return !!v1 || !!v2;
    },
    rowIsVencida(row) {
      const entregaKey = Object.keys(row).find((k) => String(k).toLowerCase().includes("entrega"));
      if (!entregaKey) return false;
      const d = this.toDateMaybe(row[entregaKey]);
      if (!d) return false;
      return d.getTime() < Date.now();
    },
    rowIsProxima(row) {
      const minKey = Object.keys(row).find((k) => String(k).toLowerCase().includes("min"));
      if (minKey) {
        const n = Number(row[minKey]);
        if (Number.isFinite(n)) return n >= 0 && n <= 120;
      }
      return false;
    },
    async cargarCatalogos() {
      this.loadingCatalogos = true;
      try {
        const fechaInicio = this.normalizeDateTime(this.filtros.fechaInicio);
        const fechaFin = this.normalizeDateTime(this.filtros.fechaFin);
        const trabajoOrdenParams = {};
        if (fechaInicio) trabajoOrdenParams.fechaInicio = fechaInicio;
        if (fechaFin) trabajoOrdenParams.fechaFin = fechaFin;

        const [otRes, maqRes, paroRes, subParoRes] = await Promise.allSettled([
          axios.get("/Paros/TrabajoOrdenHeadersConOperacionReal", {
            params: trabajoOrdenParams,
          }),
          axios.get("/MaquinaInstancias"),
          axios.get("/ParoTipos"),
          axios.get("/SubParoTipos"),
        ]);
        this.trabajoOrdenes = otRes.status === "fulfilled" ? (otRes.value?.data || []) : [];
        this.maquinas = maqRes.status === "fulfilled" ? (maqRes.value?.data || []) : [];
        this.paroTipos = paroRes.status === "fulfilled" ? (paroRes.value?.data || []) : [];
        this.subParoTipos = subParoRes.status === "fulfilled" ? (subParoRes.value?.data || []) : [];
        if (
          this.filtros.idTrabajoOrden &&
          !this.trabajoOrdenes.some(
            (x) => Number(x?.idTrabajoOrden) === Number(this.filtros.idTrabajoOrden)
          )
        ) {
          this.filtros.idTrabajoOrden = null;
          this.filtros.idMaquinaIns = null;
          this.maquinasOdt = [];
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.loadingCatalogos = false;
      }
    },
    buildParams() {
      const params = {
        idTrabajoOrden: this.filtros.idTrabajoOrden,
        idMaquinaIns: this.filtros.idMaquinaIns,
        fechaInicio: this.normalizeDateTime(this.filtros.fechaInicio),
        fechaFin: this.normalizeDateTime(this.filtros.fechaFin),
      };
      if (this.filtros.idParoTipo != null) params.idParoTipo = this.filtros.idParoTipo;
      if (this.filtros.idSubParoTipo != null) params.idSubParoTipo = this.filtros.idSubParoTipo;
      return params;
    },
    unwrapResponse(payload) {
      if (payload?.data !== undefined) return payload.data;
      if (payload?.Data !== undefined) return payload.Data;
      if (payload?.result !== undefined) return payload.result;
      if (payload?.Result !== undefined) return payload.Result;
      return payload;
    },
    async consultarSecuencia() {
      if (!this.canSearch || this.loading) return;
      this.loading = true;
      this.error = null;
      try {
        const params = this.buildParams();
        const { data } = await axios.get("/Paros/Secuencia", { params });
        const unwrapped = this.unwrapResponse(data);
        this.rawResponse = Array.isArray(unwrapped) ? unwrapped : [];
      } catch (err) {
        this.rawResponse = [];
        this.error =
          err?.response?.data?.mensaje ||
          err?.response?.data?.message ||
          err?.message ||
          "No se pudo consultar el endpoint.";
      } finally {
        this.loading = false;
      }
    },
    limpiar() {
      this.error = null;
      this.errorMaquinas = null;
      this.rawResponse = null;
      this.maquinasOdt = [];
      this.expandedGroups = {};
      this.filtros = {
        idTrabajoOrden: null,
        idMaquinaIns: null,
        fechaInicio: "",
        fechaFin: "",
        idParoTipo: null,
        idSubParoTipo: null,
      };
    },
  },
};
</script>

<style scoped>
.odt-root {
  background: #f4f7fb;
  border: 1px solid #dfe6f1;
  border-radius: 14px;
  padding: 16px;
}

.odt-controls-bar {
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  margin-bottom: 10px;
}

.odt-controls-left {
  align-items: center;
  display: flex;
  gap: 10px;
}

.odt-controls-right {
  align-items: center;
  display: flex;
  gap: 10px;
}


.odt-filter-panel {
  background: #fff;
  border: 1px solid #dbe4f1;
  border-radius: 14px;
  margin-bottom: 14px;
  padding: 12px;
}

.odt-filter-row {
  align-items: stretch;
}

.odt-filter-col {
  display: flex;
}

.odt-field {
  width: 100%;
}

.odt-actions {
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 8px;
}

.odt-kpi-grid {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin-bottom: 12px;
}

.odt-kpi-card {
  background: #fff;
  border: 1px solid #d8e2ef;
  border-radius: 20px;
  cursor: pointer;
  min-height: 120px;
  padding: 12px;
}

.odt-kpi-card--blue { border-color: #8fc1f3; }
.odt-kpi-card--violet { border-color: #c7b8f6; }
.odt-kpi-card--amber { border-color: #f0be82; }
.odt-kpi-card--slate { border-color: #f0b2b7; }
.odt-kpi-card--active { box-shadow: 0 0 0 2px #2e8aed inset; }

.odt-kpi-top { display: flex; justify-content: space-between; }
.odt-kpi-top-main { align-items: center; display: flex; gap: 10px; }
.odt-kpi-icon-pack {
  align-items: center;
  border-radius: 14px;
  display: inline-flex;
  height: 42px;
  justify-content: center;
  width: 42px;
}
.odt-kpi-icon-pack--blue { background: #d8e9fb; }
.odt-kpi-icon-pack--violet { background: #ece6ff; }
.odt-kpi-icon-pack--amber { background: #fde7c7; }
.odt-kpi-icon-pack--slate { background: #f6d9dd; }
.odt-kpi-title { color: #1c2639; font-weight: 700; margin: 0; }
.odt-kpi-value-row { display: flex; justify-content: center; margin-top: 8px; }
.odt-kpi-value-main { font-size: 2rem; font-weight: 800; margin: 0; }
.odt-kpi-value-main--blue { color: #2d84da; }
.odt-kpi-value-main--violet { color: #6d50d7; }
.odt-kpi-value-main--amber { color: #f08b00; }
.odt-kpi-value-main--slate { color: #ee5159; }
.odt-kpi-caption { color: #657993; margin: 8px 0 0; }

.odt-section-label {
  align-items: center;
  color: #3e5576;
  display: flex;
  font-size: 0.85rem;
  font-weight: 800;
  gap: 8px;
  letter-spacing: 0.22em;
  margin: 14px 0 8px;
}

.odt-dot {
  background: #2e8aed;
  border-radius: 999px;
  display: inline-block;
  height: 8px;
  width: 8px;
}

.odt-count-badge {
  background: #eaf0f9;
  border-radius: 999px;
  color: #5f7390;
  font-size: 0.72rem;
  letter-spacing: 0.08em;
  margin-left: auto;
  padding: 4px 10px;
}

.odt-panel {
  background: #fff;
  border: 1px solid #d8e2ef;
  border-radius: 14px;
  overflow: hidden;
}

.odt-loader {
  align-items: center;
  display: flex;
  gap: 8px;
  padding: 10px 12px 0;
}

.odt-loader-text { color: #5f7390; }

.odt-table-wrap { overflow: auto; }

.odt-table {
  border-collapse: collapse;
  min-width: 900px;
  width: 100%;
}

.odt-th {
  background: #f4f8fd;
  border-bottom: 1px solid #dde6f0;
  color: #2d4666;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  padding: 10px;
  text-align: left;
  white-space: nowrap;
}

.odt-th--sortable { cursor: pointer; }

.odt-td {
  border-bottom: 1px solid #edf2f8;
  color: #314864;
  font-size: 0.86rem;
  padding: 9px 10px;
}

.odt-tr:hover { background: #fafcff; }
.odt-tr--clickable { cursor: pointer; }

.odt-td--center { text-align: center; }

.odt-tr-detail { background: #f9fbff; }
.odt-td-detail { padding: 0 !important; }

.odt-subtable-wrap {
  overflow: auto;
  padding: 10px 12px;
}

.odt-subtable {
  border-collapse: collapse;
  min-width: 920px;
  width: 100%;
}

.odt-subtable th,
.odt-subtable td {
  border-bottom: 1px solid #edf2f8;
  font-size: 0.84rem;
  padding: 8px 10px;
  text-align: left;
}

.odt-subtable th {
  background: #f2f7fe;
  color: #314864;
  font-weight: 700;
}

.odt-empty {
  color: #7a8ea9;
  padding: 24px;
  text-align: center;
}

@media (max-width: 1200px) {
  .odt-kpi-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .odt-controls-bar { align-items: flex-start; flex-direction: column; }
  .odt-controls-left { width: 100%; }
}

@media (max-width: 700px) {
  .odt-kpi-grid { grid-template-columns: 1fr; }
}
</style>
